module.exports = __webpack_public_path__ + "img/veselo-sky.363fd173.png";